// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1xf5V","inputWrap":"Table_inputWrap__oBSUM","col":"Table_col__1y7Hm","bmiTooltip":"Table_bmiTooltip__1kMNG"};